const presentismoInitialState = {
    presentismo: {
        loading: false,
        error: null,
        data: null
    },
};

export default presentismoInitialState;